import { render, staticRenderFns } from "./StatusTable.vue?vue&type=template&id=64967fd2&scoped=true"
import script from "./StatusTable.vue?vue&type=script&lang=js"
export * from "./StatusTable.vue?vue&type=script&lang=js"
import style0 from "./StatusTable.vue?vue&type=style&index=0&id=64967fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64967fd2",
  null
  
)

export default component.exports